import { render, staticRenderFns } from "./CertTmpl.vue?vue&type=template&id=719dd6f2"
import script from "./CertTmpl.vue?vue&type=script&lang=js"
export * from "./CertTmpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports